<div class="form-group">
  <quill-editor
    #editor
    format="html"
    [modules]="quillConfig"
    [formlyAttributes]="field"
    [style.display]="to['hide'] ? 'none' : 'block'"
    class="bg-white rounded-lg border border-light"
    [styles]="to['styles']"
    [formControl]="$any(formControl)"
    [required]="to['required'] || false"
    [placeholder]="to.placeholder">
  </quill-editor>
</div>
